import axiosInstance from './axios';

export const uploadService = {
  uploadMedia: async (file, type, folder = 'products') => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', type);
    formData.append('folder', folder);

    console.log('Uploading file:', {
      name: file.name,
      size: file.size,
      type: file.type,
      folder: folder
    });

    const response = await axiosInstance.post('/upload/media', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      timeout: 120000, // 2 minutes timeout for large files
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        console.log('Upload progress:', percentCompleted + '%');
      },
    });

    console.log('Upload response:', response.data);

    // Verify the response has the expected data
    if (!response.data || !response.data.url || !response.data.path) {
      throw new Error('Invalid upload response - missing URL or path');
    }

    return response.data;
  },

  deleteMedia: async (url) => {
    const response = await axiosInstance.post('/delete/media', { url });
    return response.data;
  },

  // Convenience wrapper: upload a single image and return its URL string.
  // Used by forms that just need the resulting URL (e.g. promo pack image).
  uploadImage: async (file, folder = 'products') => {
    const data = await uploadService.uploadMedia(file, 'image', folder);
    return data.url;
  },
};
